(function() { module.exports = window["wp"]["serverSideRender"]; }());